<template>
  <div class="resume-project-experience-wrap clearfix" v-if="project&&project.length">
    <div class="progress-content">
      <ul>
        <li class="clearfix" v-for="(pro,index) in project" :key="index">
          <em></em>
          <i></i>
          <div class="info-box">
            <p>{{pro.startTime}} - {{pro.endTime | formatMonthSelect}}（{{pro | timeRange}}）</p>
            <p v-if="pro.projectName" v-html="pro.projectName"></p>
          </div>
          <ul class="inner-list-info clearfix">
            <li v-if="pro.companyName">
              <span class="label">所在公司</span>
              <p v-html="pro.companyName"></p>
            </li>
            <li v-if="pro.projectJobTitle">
              <span class="label">项目职务</span>
              <p v-html="pro.projectJobTitle"></p>
            </li>
            <li>
              <span class="label">项目描述</span>
              <p v-html="pro.description"></p>
            </li>
            <li>
              <span class="label">项目职责</span>
              <p v-html="pro.projectDuty"></p>
            </li>
            <li v-if="pro.achievement">
              <span class="label">项目业绩</span>
              <p v-html="pro.achievement"></p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>
<style scoped lang="scss">
.resume-project-experience-wrap {
  .progress-content{
    >ul{
      >li{
        .info-box{
          margin-left: 0;
        }
      }
    }
  }
  
}
</style>
<script>
export default {
  props:{
    project: {}
  },
  data(){
    return{
    };
  },
  components: {
  },
  methods: {
  },
  created() {
  }
};
</script>
